import { render } from "./CRMWhatsappContactLocationDialog.vue?vue&type=template&id=38e9c4f2&scoped=true"
import script from "./CRMWhatsappContactLocationDialog.vue?vue&type=script&lang=js"
export * from "./CRMWhatsappContactLocationDialog.vue?vue&type=script&lang=js"

import "./CRMWhatsappContactLocationDialog.vue?vue&type=style&index=0&id=38e9c4f2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38e9c4f2"]])

export default __exports__